module.exports = __webpack_public_path__ + "panel2fr.png?502afbfc28baff6922073a7a4f0801bf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/panel2fr.png
// module id = 58
// module chunks = 0